import { defineMessages } from 'react-intl';

const messages = defineMessages({
  billingAndSubscription: {
    id: 'RhClvn',
    defaultMessage: 'Billing & Subscription',
    description: 'Display category label for billing and subscription notifications',
  },
  usageAndLimits: {
    id: 'EfbASR',
    defaultMessage: 'Usage & Limits',
    description: 'Display category label for usage and limit notifications',
  },
  security: {
    id: 'kXurI5',
    defaultMessage: 'Security',
    description: 'Display category label for security notifications',
  },
  imports: {
    id: 'KePLvp',
    defaultMessage: 'Imports',
    description: 'Display category label for import notifications',
  },
  exports: {
    id: 'tUrIbr',
    defaultMessage: 'Exports',
    description: 'Display category label for export notifications',
  },
  labelCreation: {
    id: 'O1kbcm',
    defaultMessage: 'Label Creation',
    description: 'Display category label for label creation notifications',
  },
  inventory: {
    id: 'HMLkpQ',
    defaultMessage: 'Inventory',
    description: 'Display category label for inventory notifications',
  },
  carrierServices: {
    id: 'x4FPm0',
    defaultMessage: 'Carrier Services',
    description: 'Display category label for carrier service notifications',
  },
  storeConnections: {
    id: 'e0ns6g',
    defaultMessage: 'Store Connections',
    description: 'Display category label for store connection notifications',
  },
  settings: {
    id: 'GbIGA1',
    defaultMessage: 'Settings',
    description: 'Display category label for settings notifications',
  },
  // Fallbacks from NotificationCategory
  billing: {
    id: 'xrpmOl',
    defaultMessage: 'Billing',
    description: 'Fallback display category label for billing notifications',
  },
  orders: {
    id: 'YpU1HN',
    defaultMessage: 'Orders',
    description: 'Fallback display category label for order notifications',
  },
  shipping: {
    id: 'X1/1qf',
    defaultMessage: 'Shipping',
    description: 'Fallback display category label for shipping notifications',
  },
  system: {
    id: 'qMbTdc',
    defaultMessage: 'System',
    description: 'Fallback display category label for system notifications',
  },
});

export { messages };
